import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import formatUrl from "utils/FormatUrl";
import styles from "./NoMoreFromMap.module.css";

export default function NoMoreFromMap({ mapVsList }: { mapVsList?: any }) {
  const dispatch = useDispatch();
  const { t, lang } = useTranslation("commonAnnonces");

  const listings = useSelector(ListingreducerSelectors.listingsSelector);
  const searchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  const [filtersCount, setFiltersCount] = useState<number>(0);

  const resetFilters = () => {
    dispatch(
      ListingreducerActions.searchListings({
        refreshing: false,
      })
    );
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          prixmax: null,
          prixmin: null,
          caracteristiques: [],
          typologie: [],
          surfacemin: null,
          surfacemax: null,
          quartier: [],
          meublee: false,
          type: [],
          // page: 0,
          // sort: "date_desc",
        },
      })
    );
  };

  const zoomOut = () => {
    let c = window.cartedesannonces.getCenter();
    let z = window.cartedesannonces.getZoom();
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          lat: c.lat,
          lng: c.lng,
          zoom: z - 1,
        },
      })
    );
    dispatch(
      ListingreducerActions.setMapState({
        mapState: {
          preventZoomEndAction: false,
          center: {
            lng: c.lng,
            lat: c.lat,
          },
          zoom: z - 1,
          speed: 3,
        },
      })
    );
  };

  useEffect(() => {
    if (searchPayload) {
      let count = 0;
      if (searchPayload.typologie.length > 0) {
        count++;
      }
      if (searchPayload.type.length > 0) {
        count++;
      }
      if (searchPayload.caracteristiques.length > 0) {
        count++;
      }
      if (searchPayload.surfacemax || searchPayload.surfacemin) {
        count++;
      }
      if (searchPayload.prixmax || searchPayload.prixmin) {
        count++;
      }
      if (searchPayload.meublee) {
        count++;
      }
      setFiltersCount(count);
    }
  }, [searchPayload]);

  return (
    <div className={styles.no_more_from__map__container}>
      <div
        className={`${styles.no_more_from__map__inner} ${
          lang === "ar" ? styles.to_rtl : ""
        }`}
      >
        <p className={styles.no_more__text__title}>
          {t("Aucune annonce supplémentaire dans la zone sélectionnée")}
        </p>
        {filtersCount !== 0 ? (
          <p className={styles.no_more__text}>
            {mapVsList == "MAP" ? (
              <>
                <span
                  className={styles.get_more}
                  onClick={() => {
                    zoomOut();
                  }}
                >
                  {t("Dézoomez")}
                </span>
                &nbsp;{t("ou")}&nbsp;
              </>
            ) : null}
            {/* <span
              className={styles.get_more}
              onClick={() => {
                resetFilters();
              }}
            >
              {mapVsList == "MAP"
                ? t(" réinitialisez vos critères de recherches")
                : t("Réinitialisez vos critères de recherches")}
            </span> */}
            <a
              className={styles.get_more}
              href={formatUrl(
                `/${
                  mapVsList == "MAP" ? "map?htm" : "list.htm"
                }?transaction_type=${searchPayload.transaction_type}`,
                lang
              )}
              rel="noindex,nofolllow"
            >
              {t("Réinitialisez vos critères de recherches")}
            </a>
            &nbsp; {t("pour voir plus d'annonces")}
          </p>
        ) : (
          <p className={styles.no_more__text}>
            {mapVsList == "MAP" ? (
              <>
                <span
                  className={styles.get_more}
                  onClick={() => {
                    zoomOut();
                  }}
                >
                  {t("Dézoomez")}
                </span>
                &nbsp; {t("pour voir plus d'annonces")}
              </>
            ) : (
              t(
                "Relancez une nouvelle recherche, ou utilisez la carte pour plus de résultats"
              )
            )}
          </p>
        )}
      </div>
    </div>
  );
}
